import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import AddressSelectionInfo from './Info';
import { RootState } from '../../store/reducers';
import AddressSelectionForm from './Form';
import { setSelectedGeoLocation } from '../../store/actions/GeoLocation';

interface Props {
  onAddressReset?: () => void,
  buttonLabel?: string;
}

const AddressSelection: React.FC<Props> = (props) => {
  const {
    onAddressReset,
    buttonLabel,
  } = props;
  const address = useSelector((state: RootState) => state.geolocation.selected);
  const dispatch = useDispatch();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Reset the address when a new one is attempted to be selected through URL params.
  if (params.get('postcode') && params.get('huisnummer')) {
    dispatch(setSelectedGeoLocation({ data: null }));
  }

  if (address) {
    return (
      <AddressSelectionInfo
        address={address}
        addressMapper={{
          street: 'straat',
          house_number: 'huisnummer',
          house_number_extension: 'toevoeging',
          house_letter: 'huisletter',
          postal_code: 'postcode',
          city: 'woonplaats',
        }}
        onAddressReset={() => {
          if (onAddressReset) {
            onAddressReset();
          }

          // Remove the address from the redux store.
          dispatch(setSelectedGeoLocation({ data: null }));
        }}
      />
    );
  }

  return (
    <AddressSelectionForm buttonLabel={buttonLabel} />
  );
};

export default AddressSelection;
